// src/hooks/transportations/useRestoreTransportation.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreTransportation } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";

const useRestoreTransportation = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreTransportationMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restoreTransportation,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore transportation");
        },
    });

    return {
        restoreTransportation: restoreTransportationMutate,
        isRestore: isPending || isLoading,
    };
};

export default useRestoreTransportation;
